import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  HomeOutlined, 
  ReadOutlined, 
  AppstoreOutlined, 
  PictureOutlined, 
  CommentOutlined,
  MailOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons';

const AdminLayout = ({ children }) => {
  const { currentUser, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const navItems = [
    { name: 'Gösterge Paneli', path: '/admin', icon: <HomeOutlined /> },
    { name: 'Bloglar', path: '/admin/blog', icon: <ReadOutlined /> },
    { name: 'Kategoriler', path: '/admin/categories', icon: <AppstoreOutlined /> },
    { name: 'Slaytlar', path: '/admin/slides', icon: <PictureOutlined /> },
    { name: 'Yorumlar', path: '/admin/testimonials', icon: <CommentOutlined /> },
    { name: 'İletişim Mesajları', path: '/admin/contact-messages', icon: <MailOutlined /> },
  ];

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* Mobile sidebar overlay */}
      {mobileSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={toggleMobileSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <div 
        className={`${
          sidebarCollapsed ? 'w-20' : 'w-64'
        } bg-nihal-dark text-white min-h-screen transition-all duration-300 fixed lg:relative z-50 lg:z-auto transform ${
          mobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          {!sidebarCollapsed ? (
            <>
              <div>
                <h1 className="text-lg font-bold">Admin Panel</h1>
                <p className="text-xs text-gray-300">Diyetisten Nihal Kamış</p>
              </div>
              <button 
                onClick={toggleSidebar}
                className="text-gray-400 hover:text-white lg:hidden"
              >
                <MenuFoldOutlined />
              </button>
              <button 
                onClick={toggleSidebar}
                className="text-gray-400 hover:text-white hidden lg:block"
              >
                <MenuFoldOutlined />
              </button>
            </>
          ) : (
            <button 
              onClick={toggleSidebar}
              className="text-gray-400 hover:text-white w-full flex justify-center"
            >
              <MenuUnfoldOutlined />
            </button>
          )}
          {/* Mobile close button */}
          <button 
            onClick={toggleMobileSidebar}
            className="lg:hidden text-gray-400 hover:text-white"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <nav className="mt-6">
          <ul>
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center px-4 py-3 transition-colors ${
                    location.pathname === item.path
                      ? 'bg-nihal-primary text-white'
                      : 'text-gray-300 hover:bg-gray-700'
                  }`}
                  onClick={() => setMobileSidebarOpen(false)}
                >
                  <span className="text-lg">{item.icon}</span>
                  {!sidebarCollapsed && (
                    <span className="ml-4">{item.name}</span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-700">
          <button
            onClick={handleLogout}
            className="flex items-center w-full px-4 py-3 text-gray-300 hover:bg-red-600 hover:text-white transition-colors"
          >
            <LogoutOutlined />
            {!sidebarCollapsed && (
              <span className="ml-4">Çıkış</span>
            )}
          </button>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="flex-1 bg-gray-100 min-h-screen lg:ml-0">
        {/* Mobile header */}
        <div className="lg:hidden bg-white shadow p-4 flex items-center">
          <button 
            onClick={toggleMobileSidebar}
            className="text-nihal-dark mr-4"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
          <h1 className="text-xl font-bold text-nihal-dark">Admin Panel</h1>
        </div>
        
        {/* Desktop header */}
        <div className="hidden lg:block bg-white shadow p-4">
          <h1 className="text-xl font-bold text-nihal-dark">Admin Panel</h1>
        </div>
        
        <div className="p-6">
          <div className="max-w-6xl mx-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;